<script>
import ExactSearch from '@/mixins/exactSearch'
export default {
  mixins: [ExactSearch],
  beforeCreate() {
    this.fields = ['groupCode', 'groupName']
  },
  methods: {
    getFieldTpls(model) {
      model.groupName = _.trim(model.groupName)
      model.groupCode = _.trim(model.groupCode)
      const tpls = {
        'groupName': <el-form-item title={this.$t('language.5o6upp1vp930')} label={this.$t('language.5o6upp1vp930')}><el-input v-model={model.groupName} placeholder={this.$t('language.5o6trh9vmbs0')} maxlength={30} clearable /></el-form-item>,
        'groupCode': <el-form-item title={this.$t('language.5o6upp1vp920')} label={this.$t('language.5o6upp1vp920')}><el-input v-model={model.groupCode} placeholder={this.$t('language.5o6trh9vmbs0')} maxlength={30} clearable /></el-form-item>,
      }
        this.$store.state.usersGroup.extList.forEach(item => {
                if(item.type === 'input'){
                    tpls[item.key] = <el-form-item label={item.name}><el-input v-model={model[item.key]} placeholder={this.$t('language.5o6trh9vmbs0')} maxlength={30} clearable/></el-form-item>;
                }else if(item.type === 'select'){
                    tpls[item.key] = <el-form-item label={item.name}><el-select v-model={model[item.key]} placeholder={this.$t('language.5o6trh9vmbs0')}  clearable >
                        {item.options.map(m => {
                            return <el-option key={m.code} label={m.label} value={m.value} />
                        })}
                    </el-select></el-form-item>
                }
            });
            let extFields = this.$store.state.usersGroup.extList.map(m => m.key)
            this.fields = ['groupName', 'groupCode',...extFields]
      return tpls
    },
    queryParam(){
            //获取查询参数
            console.log("获取查询参数：", this.toEnd())
            return this.toEnd()
        }
    
  }
}
</script>
